import { render, staticRenderFns } from "./DedicatedChatGPT.vue?vue&type=template&id=1e8a7c38&scoped=true&"
import script from "./DedicatedChatGPT.vue?vue&type=script&lang=js&"
export * from "./DedicatedChatGPT.vue?vue&type=script&lang=js&"
import style0 from "./DedicatedChatGPT.vue?vue&type=style&index=0&id=1e8a7c38&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e8a7c38",
  null
  
)

export default component.exports